<i18n src='../common_locales.yaml'></i18n>
<i18n>
en:
  address: "Address"
  address_1: "Address 1 "
  address_2: "Address 2"
  autofill_address: "address"
  bank_transfer: "Bank transfer"
  building_number: "Building number"
  cash: "Cash on pickup/delivery"
  city_district: "City / District"
  city: "City"
  district: "District"
  company_name: "Company name"
  country: "Country"
  delivery_address: "Delivery address"
  delivery_date: "Delivery date"
  delivery_notes: "Delivery notes"
  delivery_time: "Delivery time"
  email: "Email"
  english: "English"
  form_error: "Error in form. Please check all fields."
  full_name: "Full name"
  hot_delivery: "Hot Delivery"
  including_country_code: "Number including Contry Code"
  is_required: "is required"
  japanese: "Japanese"
  order_completed: "Order Completed"
  order_summary: "Order summary"
  payment_method: "Payment Method"
  payment: "Payment"
  personal_details: "Personal details"
  phone: "Phone"
  pickup_date: "Pick-up Date"
  pickup_notes: "Pick-up Notes"
  pickup_time: "Pick-up Time"
  postcode_finder: "Postcode finder"
  postcode: "Post code"
  prefecture_state: "Prefecture / State"
  preferred_time: "Preferred time"
  remove: "Remove"
  submit_order: "Submit order"
ja:
  address: "住所"
  address_1: "住所 一 "
  address_2: "住所 二"
  bank_transfer: "銀行振込"
  building_number: "ビルド番号"
  cash: "現金"
  city: "都市"
  district: "地区"
  city_district: "都市| 地区"
  company_name: "会社名"
  country: "国"
  delivery_address: "配達先住所"
  delivery_date: "配送日"
  delivery_notes: "配達メモ"
  delivery_time: "納期"
  email: "Eメール"
  form_error: "フォームにエラーがあります"
  full_name: "氏名"
  is_required: "必要です"
  order_completed: "注文完了"
  order_summary: "注文の概要"
  payment: "Payment"
  payment_method: "Payment Method"
  personal_details: "個人情報"
  phone: "電話番号"
  pickup_date: "Pick-up Date"
  pickup_notes: "Pick-up Notes"
  pickup_time: "Pick-up Time"
  postcode: "郵便番号"
  prefecture_state: "県"
  hot_delivery: "出来立て配送"
  preferred_time: "優先時間"
  remove: "デリート"
  submit_order: "注文を送信"
  including_country_code: "国番号を含む電話番号"
  postcode_finder: "郵便番号ファインダー"
</i18n>
<template lang="pug">
form
  .form-group.row
    label.col-sm-3.col-form-label.required {{$t('postcode')}}
    .col-sm-4
      input.form-control(type="text" v-model="dirtyValue.postcode" @keyup="fillBillingAddress" :class="{'is-invalid': v.postcode.$error}")
      small
        a.text-primary(@click.prevent="openPostcodePicker") {{$t('postcode_finder')}}
      .invalid-feedback(v-if="!v.postcode.required") {{$t('postcode')}} {{$t('is_required')}}
      .invalid-feedback(v-if="!v.postcode.postcode") Invalid postcode
  .form-group.row
    label.col-sm-3.col-form-label.required {{$t('prefecture_state')}}
    .col-sm-4
      input.form-control(type="text" v-model="dirtyValue.prefecture" disabled :class="{'is-invalid': v.prefecture.$error}")
      .invalid-feedback {{$t('prefecture_state')}} {{$t('is_required')}}
  .form-group.row
    label.col-sm-3.col-form-label.required {{$t('city')}}
    .col-sm-4
      input.form-control(type="text" v-model="dirtyValue.city" disabled :class="{'is-invalid': v.city.$error}")
      .invalid-feedback {{$t('city')}} {{$t('is_required')}}
  .form-group.row
    label.col-sm-3.col-form-label.required  {{$t('district')}}
    .col-sm-7
      input.form-control(type="text" v-model="dirtyValue.area" :class="{'is-invalid': v.area.$error}")
      .invalid-feedback {{$t('district')}} {{$t('is_required')}}
  .form-group.row
    label.col-sm-3.col-form-label.required {{$t('address')}}
    .col-sm-7
      input.form-control(type="text" v-model="dirtyValue.address" :class="{'is-invalid': v.address.$error}")
      .invalid-feedback {{$t('address')}} {{$t('is_required')}}
</template>

<script>
import Vue from 'vue'
import api from '../api'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['value', 'v', 'kanji'],
  data () {
    return {
      postcodeEventBus: new Vue(),
      dirtyValue: this.value,
      fetchingPostcode: false
    }
  },
  computed: {
    ...mapGetters({
      cartRestaurant: 'getCartRestaurant'
    }),
    lang () {
      if (this.$i18n.locale === 'ja') return 'ja'
      else {
        return this.kanji ? 'ja' : 'en'
      }
    }
  },
  watch: {
    dirtyValue (val) {
      this.$emit('input', val)
    },
    kanji (val) {
      this.fillBillingAddress(true)
    }
  },
  created () {
    this.postcodeEventBus.$on('updated', postcode => {
      this.dirtyValue.postcode = postcode
      this.setPoscode()
      this.fillBillingAddress()
    })
    console.log(this.cartRestaurant)
  },
  methods: {
    ...mapActions([
      'setOrderPostcode'
    ]),
    setPoscode () {
      // if (this.postcode.replace('-', '').length !== 7) {
      //   this.postcodeErrorMessage = 'Please enter valid postcode'
      //   return
      // }
      var convertedPostcode = this.dirtyValue.postcode.replace('-', '')
      api.get('/postcodes/' + convertedPostcode + '/?restaurant_public_id=' + this.cartRestaurant.public_ident)
      .then(response => {
        if (response.data.hot_delivery_supported) {
          this.setOrderPostcode(response.data)
        } else {
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    openPostcodePicker () {
      this.$modal.open('postcode-picker', {eventbus: this.postcodeEventBus, autoclose: false, validateDelivery: false})
    },
    fillBillingAddress (immediately = false) {
      var timeout = immediately ? 0 : 500
      setTimeout(() => {
        this.fetchingPostcode = true
        api.get('/postcodes/' + this.dirtyValue.postcode.replace('-', '') + '/')
        .then(response => {
          var p = response.data
          this.dirtyValue.prefecture = p['prefecture_' + this.lang]
          this.dirtyValue.city = p['city_' + this.lang]
          this.dirtyValue.area = p['area_' + this.lang]
        })
        .finally(() => {
          this.fetchingPostcode = false
        })
      }, timeout)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/DeliveryAddressForm.vue